<template>
  <div class="checkbox-wrapper">
    <div class="checkbox-inner">
      <label class="checkbox">
        <input
          type="checkbox"
          class="checkbox__input"
          tabindex="0"
          @keydown.space="onClick"
        >
        <div
          class="checkbox__custom"
          @click="onClick"
        >
          <Transition name="drop">
            <Checkmark
              v-if="value"
              class="checkbox__custom-checkmark"
            />
          </Transition>
        </div>
      </label>

      <div class="checkbox__text" @click="onClick">
        <slot />
      </div>
    </div>

    <Transition name="slide-from-top">
      <span
        v-if="error && errorMsg"
        class="checkbox__error-msg"
      >
        {{ errorMsg }}
      </span>
    </Transition>
  </div>
</template>

<script>
  import Checkmark from '@/assets/img/icons/checkmark.svg?inline'

  export default {
    name: 'BaseCheckbox',
    components: {
      Checkmark
    },
    props: {
      typeNumber: Boolean,
      value: [Boolean, Number],
      errorMsg: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        error: null
      }
    },
    watch: {
      errorMsg: {
        handler (msg) {
          this.error = !!msg
        },
        immediate: true
      }
    },
    methods: {
      onClick (event) {
        const target = event.target
        if (target.tagName === 'A') {
          event.preventDefault()
        } else {
          this.error = false
          this.$emit('input', this.typeNumber ? Number(!this.value) : !this.value)
        }
      }
    }

  }
</script>

<style lang="scss">
  $padding-for-error: 28px;

  .checkbox {
    display: inline-block;
    flex-shrink: 0;
    width: 18px;
    height: 18px;

    &-inner {
      display: flex;
      align-items: center;
    }

    &-wrapper {
      position: relative;
      padding-bottom: $padding-for-error;
    }

    &__custom {
      width: 100%;
      height: 100%;
      cursor: pointer;
      border: 2px solid $c-gray-light;
      border-radius: 4px;
      transition: 0.3s;

      @include hover {
        border-color: $c-gray-medium;
      }

      &-checkmark {
        width: 9px;
        height: 9px;
        margin-bottom: 2px;
        margin-left: 2px;
        fill: $c-active-light;
      }
    }

    &__input {
      position: absolute;
      left: -9999999px;
      width: 0;
      height: 0;
      opacity: 0;

      &:focus {
        & + .checkbox__custom {
          border-color: $c-gray-medium;
        }
      }
    }

    &__text {
      margin-left: 8px;
    }

    &__error-msg {
      min-width: 300px;
      position: absolute;
      bottom: 23px;
      left: 0;
      height: 0;
      font-size: 12px;
      color: $c-active-light;
    }
  }
</style>
